import { isRecord } from "./connectionConfig";

type JsonObjectParseResult =
  | { error: string; ok: false }
  | { ok: true; value: Record<string, unknown> };

export function parseJsonObject(
  value: string,
  label: string,
): JsonObjectParseResult {
  try {
    const parsed: unknown = JSON.parse(value);
    if (!isRecord(parsed)) {
      return { error: `${label} must be a JSON object.`, ok: false };
    }
    return { ok: true, value: parsed };
  } catch {
    return { error: `${label} must be valid JSON.`, ok: false };
  }
}

type OptionalJsonObjectParseResult =
  | { error: string; ok: false }
  | { ok: true; value: Record<string, unknown> | null };

export function parseOptionalJsonObject(
  value: string,
  label: string,
): OptionalJsonObjectParseResult {
  if (value.trim().length === 0) {
    return { ok: true, value: null };
  }
  return parseJsonObject(value, label);
}
